import { addDays, differenceInCalendarDays, isValid } from "date-fns";

export const PREGNANCY_DURATION_DAYS = 280;

export const computeEddFromLmp = (lmp: Date): Date =>
  addDays(lmp, PREGNANCY_DURATION_DAYS);

export type GestationalAge = { weeks: number; days: number };

export const computeGestationalAge = (
  referenceDate: Date,
  lmp: Date,
): GestationalAge | null => {
  if (!isValid(referenceDate) || !isValid(lmp)) return null;
  const totalDays = differenceInCalendarDays(referenceDate, lmp);
  if (totalDays < 0) return null;
  return {
    weeks: Math.floor(totalDays / 7),
    days: totalDays % 7,
  };
};

export const computeGestationalAgeFromEdd = (
  referenceDate: Date,
  edd: Date,
): GestationalAge | null => {
  if (!isValid(edd)) return null;
  const lmpEquivalent = addDays(edd, -PREGNANCY_DURATION_DAYS);
  return computeGestationalAge(referenceDate, lmpEquivalent);
};

// EDD is considered "manually overridden" when it differs from LMP+280 by more
// than one calendar day — small drift (e.g. midnight rounding) is ignored.
export const isEddManuallyOverridden = (
  lmp: Date | null | undefined,
  edd: Date | null | undefined,
  toleranceDays = 1,
): boolean => {
  if (!lmp || !edd || !isValid(lmp) || !isValid(edd)) return false;
  const expected = computeEddFromLmp(lmp);
  return Math.abs(differenceInCalendarDays(edd, expected)) > toleranceDays;
};
